import GooglePlay from './img/GooglePlay.webp';
import AppStore from './img/AppStore.webp';

export const getMobileContent = (
    isIOS?: boolean
): { data: { text: string; disclaimer?: string; image?: string }[] } => {
    return {
        data: [
            {
                text: 'downloadPage.downloadApp',
                image: isIOS ? AppStore : GooglePlay,
            },
            {
                text: 'downloadPage.chooseLogin',
            },
            {
                text: 'downloadPage.enterEmail',
                disclaimer: 'downloadPage.loginDisclaimer',
            },
            {
                text: 'downloadPage.startWorkout',
            },
        ],
    };
};

export const getDesktopContent = (): {
    data: { text: string; disclaimer?: string }[];
} => {
    return {
        data: [
            {
                text: 'downloadPage.scanQR',
            },
            {
                text: 'downloadPage.downloadApp',
            },
            {
                text: 'downloadPage.chooseLogin',
            },
            {
                text: 'downloadPage.enterEmail',
                disclaimer: 'downloadPage.loginDisclaimer',
            },
            {
                text: 'downloadPage.startWorkout',
            },
        ],
    };
};
